// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()
import App from './App'
import router from './router' // 导入路由文件
import store from './store' // 导入vuex文件
import api from './api' // 导入api接口
import axios from 'axios'
import bus from "@/untils/eventBus";

// 全局过滤器
import * as filters from '@/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import { Toast } from 'vant';
Vue.prototype.$toast = Toast; // Toast提醒
Vue.prototype.$api = api; // 将api挂载到vue的原型上复制代码
Vue.prototype.$axios = axios
Vue.prototype.bus = bus;

import vant from './components/vant'
Vue.use(vant)
import "vant/lib/toast/style";
import './styles/index.less'

Vue.config.productionTip = false
Vue.config.devtools = true

//跳转页面
Vue.prototype.toPage = function (urls){
  if(urls.indexOf('http')>-1){
    window.location.href = urls;
  }else{
    this.$router.push(urls);
  }
}
// 判断登录状态回调RN
// const token = localStorage.getItem('token')
// if(!token){
  if(window.ReactNativeWebView)window.ReactNativeWebView.postMessage(JSON.stringify({type:1,msg:'未登录，请登录!'}));
// }
const u = navigator.userAgent;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
if (isiOS) {
  // 接收来自 RN 的参数
  window.addEventListener('message', function (e) {
    const message = e.data;//字符串类型
    // alert('web=='+JSON.stringify(message));
    if(message&&typeof(message)=='string'&&message.length>50){
      let tokenObj = JSON.parse(message)
      if(tokenObj&&tokenObj.token&&tokenObj.token.length>50){
        localStorage.setItem('token',tokenObj.token)
        // alert(tokenObj.token)
      }
    }
  })
} else {
  document.addEventListener('message', function (e) {
    const message = e.data;//字符串类型
    // alert('web=='+JSON.stringify(message));
    if(message&&typeof(message)=='string'&&message.length>50){
      let tokenObj = JSON.parse(message)
      if(tokenObj&&tokenObj.token&&tokenObj.token.length>50){
        localStorage.setItem('token',tokenObj.token)
        // alert(tokenObj.token)
      }
    }
  })
}
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    render: h => h(App),
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js